import React, { useRef, useState } from 'react';
import {
  AquistaButton,
  AquistaButtonsContainer,
  LeftCol,
  LogoPriceContainer,
  QuotationCardStyles,
  RightCol,
  SavedButton,
  AiChatButton,
} from '../components/redesignComponents/ResultPageComponents/v2/QuotationCard.styles';
import LogoComponent from './smallerComponents/LogoComponent';
import CompanyQualityComponent from './smallerComponents/CompanyQualityComponent';
import PriceComponent from './smallerComponents/PriceComponent';
import CompanyInfoComponent from './smallerComponents/CompanyInfoComponent';
import QuoteInfoComponent from './smallerComponents/QuoteInfoComponent';
import SparklesIcon from '../../assets/images/icons/SparklesIcon';
import { Chat } from '../components/chats/MiniChat/MiniChat';
import getChatSubProduct from '../helpers/getChatSubProduct';

function QuotationCard({
  quote,
  requestInfo,
  selectQuotation,
  guaranteesPrima,
  set_informativi,
  docs,
  extensions,
  requestToken,
  selectableExtensions,
  profession,
  type,

}) {
  const [openChat, setOpenChat] = useState(false);
  const [extraText, setExtraText] = useState();
  const chatRef = useRef();

  return (
    <QuotationCardStyles className={quote.is_aquista === 1 ? 'selected' : ''}>
      <LeftCol>
        <div>
          {/* Company Quality Component */}
          <CompanyQualityComponent quote={quote} />
          {/*
           * Data-driven semestrale-downgrade warning.
           *
           * Fires whenever the broker requested semestrale
           * (`requestInfo.payment_frequency === 2`) but the saved quote ended
           * up annual (`quote.payment_frequency === 1`). For Facile-sourced
           * quotes this happens at save-time when the insurer's
           * `extraFeatures` doesn't include `six-monthly-payable`. For direct
           * integrations (Linear, Genial Più) the same comparison covers the
           * historical hard-coded warnings.
           *
           * Uses the company name from the saved row so a future Facile
           * insurer that doesn't support semestrale gets the warning
           * automatically, no code change needed.
           */}
          {requestInfo.payment_frequency === 2
            && quote.payment_frequency === 1 && (
              <div className="alert alert-warning mt-1 mb-2 p-1 w-100">
                <b>Attenzione:</b>
                {' '}
                {(quote.company && quote.company.name)
                  || (quote.preventivas_company && quote.preventivas_company.company_name)
                  || 'Questa compagnia'}
                {' '}
                non supporta il pagamento semestrale.
              </div>
          )}
          <LogoPriceContainer>
            {/* Logo Component */}
            <LogoComponent quote={quote} />
            {/* Price Component */}
            <PriceComponent quote={quote} />
          </LogoPriceContainer>
        </div>
        {/* {!(quote.company_id === 1001 && quote.product_id === 10) && (

        )} */}
        <>
          <AiChatButton onClick={() => setOpenChat(true)}>
            <SparklesIcon width={24} height={24} />
            <span>Chiedi all'AI</span>
          </AiChatButton>
          <Chat
            ref={chatRef}
            openChat={openChat}
            setOpenChat={setOpenChat}
            company_id={
              quote.company ? quote.company_id : quote.preventivas_company_id
            }
            product_id={quote.product_id}
            sub_product={getChatSubProduct(quote, requestInfo)}
            quoteId={quote?.id}
            company_name={
              quote.company
                ? quote.company.name
                : quote.preventivas_company.company_name
            }
            extraText={extraText}
            professionId={profession?.profession}
          />
        </>
      </LeftCol>
      <RightCol>
        {/* Company Info Component */}
        <div>
          <CompanyInfoComponent
            quote={quote}
            guaranteesPrima={guaranteesPrima}
            set_informativi={set_informativi}
            docs={docs}
            extensions={extensions}
            requestToken={requestToken}
            selectableExtensions={selectableExtensions}
            profession={profession}
            requestInfo={requestInfo}
          />
          {/* Quote Info Component */}
          <QuoteInfoComponent
            setExtraText={setExtraText}
            quote={quote}
            requestInfo={requestInfo}
            profession={profession}
            type={type}
          />
        </div>
        <AquistaButtonsContainer>
          {requestInfo.processing_quotation_id !== quote.id ? (
            <AquistaButton
              onClick={() => selectQuotation(quote.id)}
              className="purchase-quote-nine-step"
            >
              Seleziona
            </AquistaButton>
          ) : (
            requestInfo.processing_quotation_id === quote.id && (
              <SavedButton>Aggiunto</SavedButton>
            )
          )}
        </AquistaButtonsContainer>
      </RightCol>
    </QuotationCardStyles>
  );
}

export default QuotationCard;
